import AppTd from "@/components/AppTd";
import ContentMixin from "@/mixins/ContentMixin.vue";
import SeoChildProductCell from "@/components/seo/SeoChildProductCell.vue";
import SeoItemHighlightCell from "@/components/seo/SeoItemHighlightCell.vue";
import SeoImagesCountCell from "@/components/seo/SeoImagesCountCell.vue";
import SeoBulletPointCell from "@/components/seo/SeoBulletPointCell.vue";
import SeoSearchTermsCell from "@/components/seo/SeoSearchTermsCell.vue";
import SeoDescriptionCell from "@/components/seo/SeoDescriptionCell.vue";
import SeoImageCell from "@/components/seo/SeoImageCell.vue";
import SeoAmazonScoreCell from "@/components/seo/SeoAmazonScoreCell.vue";
import SeoOmnyScoreCell from "@/components/seo/SeoOmnyScoreCell.vue";
import SeoPushStatusCell from "@/components/seo/SeoPushStatusCell.vue";
import SeoPencilEditCell from "@/components/seo/SeoPencilEditCell.vue";
import SeoCheckBoxCell from "@/components/seo/SeoCheckBoxCell.vue";
import SeoCategoryCell from "@/components/seo/SeoCategoryCell.vue";
import SeoAPlusCell from "@/components/seo/SeoAPlusCell.vue";
import SeoBrandCell from "@/components/seo/SeoBrandCell.vue";
export default {
  name: "SeoRow",
  components: {
    AppTd,
    SeoChildProductCell,
    SeoItemHighlightCell,
    SeoImagesCountCell,
    SeoBulletPointCell,
    SeoSearchTermsCell,
    SeoDescriptionCell,
    SeoImageCell,
    SeoAmazonScoreCell,
    SeoOmnyScoreCell,
    SeoPushStatusCell,
    SeoPencilEditCell,
    SeoCheckBoxCell,
    SeoCategoryCell,
    SeoAPlusCell,
    SeoBrandCell
  },
  mixins: [ContentMixin],
  emits: ["selectItem", "onEdit", "onPaste", "expandImageList", "onEditSingleItem", "onConfirmPushSingleContent", "isCopied", "onCopyingHover", "onCopyingHoverLeave", "showParent"],
  props: {
    isImageCellCollapsed: Boolean,
    pushModal: Boolean,
    isCopying: Boolean,
    showPopover: Boolean,
    activatedFilteredItems: Array,
    isFilteredChildren: Boolean,
    isLastItem: Boolean,
    selected_contents: Array,
    index: Number,
    showCheckBox: {
      type: Boolean,
      default: true
    },
    push_loading: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    uid() {
      //return this.tableItems.map(() => crypto.randomUUID());
      return crypto.randomUUID();
      //return this.item.content_id;
    }
    // tableItems() {
    //   const filteredKeySet = new Set(
    //     this.activatedFilteredItems.map((item) => `${item.sku}|${item.asin}`)
    //   );
    //   const tableItems = this.isFilteredChildren
    //     ? this.childrenItems.filter((element) =>
    //       filteredKeySet.has(`${element.sku}|${element.asin}`)
    //     )
    //     : this.childrenItems;
    //   return tableItems;
    // },
  },
  methods: {
    onParentLinkBtnClicked() {
      this.$emit("showParent");
    }
  }
};